<template>
    <div class="multi-select">
        <!-- :label="field.label" -->
        <b-form-group

                :label-for="`id_${field._id}`"
                :class="{
          'required-field': field.isRequired,
      }">
            <label>{{ labelByInstance }}</label>

            <multiselect
                    v-model="model"
                    tag-placeholder="field.placeholder"
                    :placeholder="placeholderByInstance"
                    :label="trackBy"
                    :track-by="trackBy"
                    :options="field.options"
                    :multiple="true"
                    :data-vv-name="labelByInstance"
                    :taggable="true"
                    :disabled = "loading || isDisable"
                    v-validate="{
            required: field.isRequired,
        }"
                    :class="{
            'is-invalid': errors.has(labelByInstance),
        }"
                    @input="setModelValue"
            ></multiselect>
            <!--      Hell-->
            <!--      {{ field.value }}-->
        </b-form-group>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import List from './List.vue'
    import request from "@/utils/request";
    import { mapGetters } from "vuex";

    export default {
        /*
         |--------------------------------------------------------------------------
         | Component > inject
         |--------------------------------------------------------------------------
         */
        inject: {
            $validator: '$validator',
        }, // End of Component > inject

        components: {
            Multiselect,
        }, // End of Component > components
      extends: List,
        props: {
            field: { type: Object }
        },
        data() {
            return {
                model: [],
                options : [],
                isDisable : false,
                fieldsToCheck:['fatcaInfo.otherResidency','fatcaInfo.taxCountries'],
                fieldsToChange:['fatcaInfo.hasOtherResidency','fatcaInfo.isCountryTax']
            }
        },
        created() {

            let index=this.fieldsToCheck.indexOf(this.field.key)
            if ( index > -1) {
                this.$store.watch(
                    (state) => {
                        let fieldName = this.fieldsToChange[index].split('.')
                        return this.$store.state.registration.form[fieldName[0]][fieldName[1]] // could also put a Getter here
                    },
                    (newValue) => {
                        if (newValue == 'yes') {
                            this.isDisable = false
                            this.field.isRequired = true
                        } else {
                            this.isDisable = true
                            this.field.isRequired = false
                            this.model = ''
                            this.setModelValue()
                        }
                    },
                )
            }
        },

        async mounted() {
            await this.getRecords();
            this.getModelValue()

            let index=this.fieldsToCheck.indexOf(this.field.key)

            if (index > -1) {
                let fieldName = this.fieldsToChange[index].split('.')

                if (this.$store.state.registration.form[fieldName[0]][fieldName[1]] == 'yes') {
                    this.isDisable = false
                    this.field.isRequired = true
                    var some = this.field.key.split('.')
                    if (this.field.customerDetails && this.field.customerDetails[some[0]][some[1]]){
                        this.model = this.field.customerDetails[some[0]][some[1]]
                        this.setModelValue()
                    }
                }
                else
                {
                    this.isDisable = true
                    this.field.isRequired = false
                    this.model = ''
                    this.setModelValue()
                }
            }
            else
            {
                var some = this.field.key

                if(this.field.key.includes('.'))
                {
                    some=this.field.key.split('.')
                    if (this.field.customerDetails && this.field.customerDetails[some[0]][some[1]]){
                        this.model = this.field.customerDetails[some[0]][some[1]]
                    }
                }
                else
                {
                    if (this.field.customerDetails && this.field.customerDetails[some]){
                        this.model = this.field.customerDetails[some]
                    }
                }
                this.setModelValue()
            }
        },
        watch: {
            dataSegmentId(value) {
                if (value) {
                    this.getRecords();
                }
            }
        },
        methods: {
            getModelValue(){
                if (this.field.isLocked) {
                    this.model = this.$store.getters.getField(this.field.key)
                } else {
                    let customInfo = this.$store.getters.getField(`customInfo`)
                    this.model = customInfo[this.field._id]
                        ? customInfo[this.field._id].value
                        : null
                }
            },
            /**
             * get the dropdown values when required
             *
             * @return {void}
             */
            setModelValue(){
                if (this.field.isLocked) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: this.model,
                    })
                } else {
                    this.$store.commit('updateField', {
                        key: `customInfo.${this.field._id}`,
                        value: {
                            title: this.field.label,
                            type: this.field.type,
                            value: this.model,
                        },
                    })
                }
            },
            async getRecords() {
                try {
                    if(this.field.isAssociation)
                    {
                        let { data } = await request({
                            url: `/configurations/${this.field.association}`,
                            params: {
                                dataSegmentId: this.dataSegmentId,
                                status: 'active',
                                perPage: 1000,
                                ref: 'dropdown',
                            },
                        })

                        // update the local list of options
                        this.field.options = data.data
                    }
                    // else
                    // {
                    //     let fieldOptions = [...this.field.options]

                    //     let tempArr= []
                    //     for(let i=0; i<fieldOptions.length;i++)
                    //     {
                    //         let tempObj={}

                    //         if(fieldOptions[i] && fieldOptions[i].text && fieldOptions[i].text!='')
                    //         {
                    //             tempObj._id=fieldOptions[i].value
                    //             tempObj.title=fieldOptions[i].text
                    //         }
                    //         tempArr.push(tempObj)
                    //     }
                    //     this.field.options=tempArr
                    // }
                } catch (error) {
                    // console.log(error);
                }
            } // End of getRecords() method
        },
        /*
         |--------------------------------------------------------------------------
         | Component > computed
         |--------------------------------------------------------------------------
         */
        computed: {

            ...mapGetters(["dataSegmentId", "loading", "form"]),
            dataSegmentId() {
                if (this.$route.params.dataSegmentId) {
                    return this.$route.params.dataSegmentId;
                }
                return this.$store.getters.dataSegmentId;
            },
            labelByInstance() {
                // field.label
                    return this.field.label
            },
            placeholderByInstance() {
                // field.label
                    return this.field.placeholder
            },
            trackBy(){
              if(this.field.options && this.field.options.length > 0 && this.field.options[0].hasOwnProperty('text') && this.field.options[0].text){
                return 'text'
              } 
              return 'title'
            },


        } // End of Component > computed

        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */


    }

</script>